export default {
  message: {
    "error": "¡Se produjo un error!",
    "Sorrysomeerrorsoccurred": "Lo sentimos, ocurrieron algunos errores",
    "quit": "Salir",
    "language": "Idioma",
    "Youcanchangethelanguagehere": "¡Puedes cambiar el idioma aquí!",
    "current": "Actual",
    "home": "Inicio",
    "friends": "Amigos",
    "wallet": "Billetera",
    "aboutus": "Sobre nosotros",
    "Sharewithfriends": "Comparte con amigos",
    "copyFailure": "Error al copiar",
    "copySuccess": "Copiado con éxito",
    "Claimreward": "Recibir recompensa",
    "DailyLogin": "Inicio de sesión diario",
    "noInvitationsYet": "Aún no hay invitaciones",
    "LoadMore": "Cargar más",
    "WatchAD": "Ver anuncio",
    "continue": "Continuar",
    "Congratulations": "Felicidades",
    "MyFriends": "Mis amigos",
    "Invitefriends": "Invitar amigos",
    "Invitepremiumfriends": "Invitar amigos premium",
    "DailyTasks": "Tareas diarias",
    "inviteDesc": "+{num} ${name} por cada amigo que invites",
    "DailyTasksDesc": "Completa tareas para obtener más ${name}",
    "SponsorsandPartners": "Patrocinadores y socios",
    "Receivingwallet": "Billetera receptora",
    "Enterwalletaddress": "Ingresa la dirección de billetera {name}",
    "Claim": "Recibir",
    "Booster": "Impulse",
    "RentPeriod": "Período de alquiler",
    "days30": "30 días",
    "days": "días",
    "Dailyprofit": "Beneficio diario",
    "Totalprofit": "Beneficio total",
    "Quantity": "Cantidad",
    "RentPrice": "Precio de alquiler",
    "RentMiner": "Alquilar minero",
    "Insufficient": "Fondos insuficientes ${name}",
    "InsufficientMsg": "{num} ${name1} necesarios, invita amigos o completa tareas para ganar más ${name2}.",
    "Settings": "Configuraciones",
    "copyid": "Copiar ID",
    "UpgradeSuccessfully": "Actualización exitosa",
    "Name": "Nombre",
    "userinfo": "Información del usuario",
    "disconnect": "Desconectar",
    "Startmining": "Comenzar a minar",
    "Welcome": "Bienvenido a {name}",
    "Withdrawal": "Retiro",
    "Minimumamount": "Cantidad mínima",
    "Networkfee": "Tarifa de red",
    "Enteramount": "Ingrese monto",
    "Submit": "Enviar",
    "MinimumTip": "El monto de retiro es demasiado pequeño. Monto mínimo de retiro: {num}",
    "MaximumTip": "Monto insuficiente, el monto máximo que puede retirar es: {num}",
    "SubmittedTip": "Enviado, se espera procesar en un plazo de 30-60 días hábiles",
    "WithdrawStatus": "Estado",
    "Submissiontime": "Hora de envío",
    "WithdrawAwaitTip": "* Se estima que tomará 30-60 días hábiles. Invitar a más amigos puede acelerar el proceso de revisión.",
    "Processing": "Procesando",
    "Amount": "Monto",
    "Numberoffriends": "Número de amigos: {now}/{limit}",
    "InviteTip": "Para realizar su primer retiro, necesita invitar a {limit} amigos a unirse a la aplicación de minería.",
    "openonphone": "Abra este enlace en su teléfono.",
    "claimTip": "El monto a recibir es demasiado pequeño. El monto mínimo a reclamar es: {num}",
    "WalletBalance": "Saldo de la billetera",
    "Withdraw": "Retirar",
    "SetWalletAddress": "Establecer dirección de billetera",
    "WithdrawalRecord": "Registro de retiro",
    "Norecords": "No hay registros",
    "Whatis": "¿Qué es {name}?",
    "All": "Todo",
    "save": "Guardar",
    "successWithdrawal": "El retiro ha sido recibido {num}",
    "secondsago": "{time} segundos atrás",
    "Loading": "Cargando...",
    "PaymentConfirming": "Comprobando estado de la transacción...",
    "Check": "Chequeo",
    "CheckFail": "Transacción no completada. Por favor, vuelva a verificar en 5 segundos.",
    "Addname": "Agregue '{name}' a su nombre",
    "Restattcheck": "Reinicie la aplicación para verificar",
    "Copyname": "Copiar '{name}'",
    "SubmissionFailed": "El envío falló, por favor intente nuevamente más tarde",
    "WithdrawalReview": "Revisión de retiro",
    "WebWithdrawAwaitTip": "* Se estima que tomará 24-48 horas. Invitar a más amigos puede acelerar el proceso de revisión.",
    "Success": "Éxito",
    "Rejection": "Rechazo",
    "WebSubmittedTip": "Enviado, se espera procesar en un plazo de 24-48 horas",
    "shop": "Tienda",
    "topurchase": "Vaya a la tienda para comprar",
    "shopDesc": "Disponibilidad limitada: ¡obtenga la suya antes de que desaparezcan!",
    "claim": "Recibir recompensas",
    "payment_success": "Pago exitoso",
    "payment_failed": "Pago fallido",
    "payment_cancelled": "Pago cancelado",
    "opening_payment": "Abrir pago...",
    "payment_status": "Estado del pago",
    "create_order_failed": "Error al crear el pedido",
    "creating_ton_order": "Creando pedido de TON...",
    "next_step": "Siguiente paso",
    "use_ton_payment": "Usar pago de TON",
    "start_transaction": "Iniciar transacción",
    "connect_wallet": "Conectar billetera",
    "address": "Dirección",
    "amount_ton": "Cantidad TON",
    "copy": "Copiar",
    "amount": "Cantidad",
    "wallet_address": "Dirección de billetera",
    "comment_memo": "Comentario memo",
    "you_can_choose_to_connect_wallet_to_pay": "Puede elegir conectar la billetera para pagar",
    "or_manually_transfer_to_the_above_address": "O transferir manualmente a la dirección anterior (tenga en cuenta que la cantidad y el memo deben ser exactamente los mismos)",
    "transaction_success": "Transacción exitosa",
    "transaction_failed": "Transacción fallida",
    "transaction_error": "Error en la transacción",
    "transaction_status": "Estado de la transacción",
    "transaction_id": "ID de la transacción",
    "transaction_amount": "Cantidad de la transacción",
    "transaction_status_desc": "Descripción del estado de la transacción",
    "payment_status_tip": "Por favor, espere a que el pago sea confirmado",
    "select_payment_method": "Seleccionar método de pago",
    "total_amount": "Monto total",
    "creating_order": "Creando orden...",
    "order_created": "Orden creada",
    "order_status": "Estado de la orden",
    "Applyforwithdrawal": "Solicitar retirada",
    "Withdrawalunlock": "Desbloqueo de retirada",
    "WithdrawalunlockTip": "Necesita {num} amigos invitados para completar tareas/unir billeteras y desbloquear la retirada",
    "Close": "Cerrar",
    "Delivering": "Entregando",
    "Duetothelargenumber": "Debido a la gran cantidad de destinatarios, se espera que su airdrop llegue en 15-20 días hábiles",
    "select_network": "Seleccionar red",
    "confirm": "confirmar",
    "switching_network": "Cambiando de red...",
    "network_switched": "Red cambiada",
    "use_usdt_payment": "Uso de pago USDT",
    "or_manually_transfer_to_the_above_address_usdt": "Transfiera manualmente a la dirección anterior (tenga en cuenta que la cantidad y la dirección deben ser exactamente las mismas)",
    "chain_type": "Red",
    "check_transaction_status": "Verificar estado de la transacción",
    "transaction_wait": "La transacción está en proceso. Puedes salir de la aplicación. Un mensaje te notificará una vez que esté completa.",
    "twa_pay_tip_with_memo": "Por favor, asegúrese de que la dirección, el monto y el memo sean consistentes para la transferencia.",
    "twa_pay_tip": "Por favor, asegúrese de que la dirección y el monto sean correctos para la transferencia.",
    "creating_usdt_order": "Creando orden de USDT...",
    "affiliate_programs": "Programas de afiliados",
    "affiliate_programs_description": "Invita a amigos a unirse a la aplicación de minería y gana recompensas.",
    "commission_details": "Detalles de la comisión",
    "no_commission_records": "No hay registros de comisiones",
    "commission_list": "Lista de comisiones",
    "input_amount": "Ingresa la cantidad",
    "max": "Máx",
    "commission_input_amount": "Ingresa la cantidad de la comisión",
    "min_commission": "El monto mínimo de retirada es {num}",
    "WithdrawalSuccess": "Retirada exitosa",
    "WithdrawalFailed": "Retirada fallida",
    "WithdrawalProcessing": "Retirada en procesamiento",
    "award": "Premio",
    "level": "Nivel",
    "Share_to_group": "Compartir en grupo",
    "Exchange": "Intercambio",
    "balance_not_enough": "Saldo no suficiente, solo puedes intercambiar {num} {coin}",
    "exchange_fail": "Intercambio fallido",
    "exchange_success": "Intercambio exitoso",
    "you_will_receive": "Recibirás",
    "ShareToGroups": "Compartir en grupos",
    "Numberofgroups": "Número de grupos: {now}/{limit}",
    "Confirm": "Confirmar",
    "ShareToGroupsDesc": "Comparte en grupos para obtener más {name}",
    "TokenAddress": "Por favor ingrese los detalles de retiro como el ID de intercambio o la dirección de USDT",
    "CashAddress": "Por favor ingrese los detalles de retiro como el número de tarjeta bancaria o la dirección de USDT",
    "Cancel": "Cancelar",
    "min_withdrawal_amount": "El monto mínimo de retiro es {num} {coin}",
    "max_withdrawal_amount": "El monto máximo de retiro es {num} {coin}",
    "withdrawal_failed": "Retiro fallido",
    "withdrawal_success": "Retiro exitoso",
    "PayNow": "Pagar ahora",
    "PaySkip": "Paga {num} para desbloquear el retiro instantáneamente",
    "NumberofGroups": "Número de grupos: {now}/{limit}",
    "SendMessage": "Enviar mensaje",
    "NumberofShares": "Número de acciones: {now}/{limit}",
    "NumberofTasks": "Número de tareas: {now}/{limit}",
    "CompleteTask": "Completar tarea",
    "PleaseEnterValidAmount": "Por favor, ingrese una cantidad válida",
    "PleaseEnterValidEmail": "Por favor, ingrese un correo electrónico válido",
    "Feedback": "Comentarios",
    "Inputfeedbackcontent": "Ingrese el contenido de los comentarios",
    "Submitfeedback": "Enviar comentarios",
    "Pleaseenteravalidemailaddress": "Por favor, ingrese una dirección de correo electrónico válida",
    "Pleaseenteryouremailaddress": "Por favor, ingrese su dirección de correo electrónico",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "Ya ha comentado hoy, por favor regrese mañana",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "Comentarios enviados con éxito, gracias por sus valiosos comentarios",
    "Feedback_submission_failed_please_retry": "Error en el envío de comentarios, por favor intente nuevamente",
    "ContactUs": "Contáctenos",
    "XRPAddress": "Por favor, rellene la dirección del monedero de la cadena XRP activada (incluido el MEMO), de lo contrario no podrá retirar efectivo.",
    "Accelerated": "Acelerado",
    "Accelerated_withdrawals_success": "Retiros acelerados con éxito",
    "login": "Iniciar sesión",
    "register": "Registrarse",
    "login_with_google": "Iniciar sesión con Google",
    "or": "O",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "no_account": "No tienes una cuenta",
    "click_to_go": "Haz clic para",
    "have_account": "Ya tienes una cuenta",
    "go_to": "Ir a",
    "invite_code": "Código de invitación",
    "optional": "Opcional",
    "google_login_not_ready": "El inicio de sesión con Google no está listo, por favor intenta de nuevo más tarde",
    "password_too_long": "La contraseña es demasiado larga",
    "weak": "Débil",
    "medium": "Media",
    "strong": "Fuerte",
    "login_success": "Inicio de sesión exitoso",
    "login_failed": "Error en el inicio de sesión",
    "please_input_email": "Por favor ingresa tu correo electrónico",
    "invalid_email": "Formato de correo electrónico inválido",
    "please_input_password": "Por favor ingresa tu contraseña",
    "password_length_6_to_16": "La contraseña debe tener entre 6 y 16 caracteres",
    "account_or_password_error": "Error en la cuenta o la contraseña",
    "register_success": "Registro exitoso",
    "register_failed": "Error en el registro",
    "save_error": "Error al guardar, por favor intenta de nuevo más tarde",
    "ShareToFriends": "Comparte con amigos",
    "login_first": "Por favor, inicie sesión primero",
    "WalletBscError": "❌ Dirección de billetera de BNB Chain inválida.",
    "DownloadWallet": "Descargar Billetera",
    "AddToHomeScreen": "Añadir {appName} a la pantalla de inicio",
    "TapShareInToolbar": "Toque en la barra de herramientas",
    "SelectAddToHomeScreen": "Seleccione añadir a la pantalla de inicio",
    "OpenToolbar": "Abrir barra de herramientas",
    "ClaimFailed": "Recompensa fallida, por favor inténtalo de nuevo más tarde",
    "guest_login": "Inicio de sesión de invitado",
    "please_input_phone": "Por favor ingrese su número de teléfono",
    "email_error_1": "Por favor ingrese su correo electrónico",
    "email_error_2": "Por favor ingrese una dirección de correo electrónico válida",
    "email_error_3": "No se permite el correo electrónico de invitado, por favor use un correo real",
    "phone": "Teléfono",
    "phone_error_1": "Por favor ingrese su número de teléfono",
    "phone_error_2": "Por favor ingrese un número de teléfono válido",
    "update_info": "Actualizar información",
    "update_success": "Actualización exitosa",
    "update_failed": "Error en la actualización, por favor intente de nuevo más tarde",
    "cancel": "Cancelar",
    "guest_credentials_title": "Información de la cuenta",
    "guest_credentials_warning": "Por favor, toma una captura de pantalla para guardar tu cuenta y contraseña. Si se pierde, ¡tus ganancias no podrán recuperarse!",
    "i_have_saved": "He guardado",
    "account": "Cuenta",
    "view_credentials": "Ver Credenciales",
    "miner_max_reached": "Has alcanzado el número máximo de este minero"
}};